import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

function toLocalInput(iso) {
  const d = new Date(iso);
  if (isNaN(d)) return "";
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}

export const CorrectEndDialog = ({ report, onClose, onDone }) => {
  const [fin, setFin] = useState(() => toLocalInput(report.planned_end));
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!fin) { toast.error("Indiquez l'heure de fin"); return; }
    setSaving(true);
    try {
      await api.post(`/gardiennage/${report.intervention_id}/correct-end`, { fin_service_at: new Date(fin).toISOString(), note });
      toast.success("Heure de fin corrigée");
      onDone(report.intervention_id);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Correction impossible");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="correct-end-dialog">
        <DialogHeader>
          <DialogTitle>Corriger l'heure de fin</DialogTitle>
          <DialogDescription>{report.agent_name} — {report.site_nom}. Clôturé automatiquement à l'heure prévue.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="correct-end-input">Heure de fin réelle</Label>
            <Input id="correct-end-input" type="datetime-local" value={fin} onChange={(e) => setFin(e.target.value)} data-testid="correct-end-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="correct-end-note">Commentaire (optionnel)</Label>
            <Textarea id="correct-end-note" value={note} onChange={(e) => setNote(e.target.value)} rows={2} data-testid="correct-end-note" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="correct-end-cancel">Annuler</Button>
          <Button onClick={save} disabled={saving} data-testid="correct-end-save">{saving ? "Enregistrement…" : "Enregistrer"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
